<span><a class="link ul" @click="openIntercomChat" :id="`js-intercom-automation-${intercomId}`" :class="linkClass">{{ linkText }}</a></span>